import css from 'styled-jsx/css';

export default css`.optionMenu {
  color: #333; }
  .optionMenu .optionMenu__content .optionMenu__section {
    position: relative;
    padding: calc(1rem + 10px) 10px 0;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap; }
    .optionMenu .optionMenu__content .optionMenu__section::before {
      content: attr(data-title);
      display: block;
      position: fixed;
      margin-top: -1em; }
    .optionMenu .optionMenu__content .optionMenu__section:empty {
      display: none; }
    .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item {
      display: inline-block;
      font-size: 0.7rem;
      margin: 12px 7px;
      text-align: center;
      cursor: pointer; }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item::before {
        content: '';
        display: block;
        margin-bottom: 8px;
        width: 62px;
        height: 62px;
        background-repeat: no-repeat;
        background-size: contain; }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--facebook::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/icon-footerNav-facebook@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--messenger::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/icon-footerNav-messenger@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--line::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/icon-footerNav-line@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--copylink::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/share-link@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--edit::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/share-edit@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--delete::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/share-delete@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--recall::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/admin-delete@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--report::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/share-alert@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--block::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/share-block@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--feedback::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/share-report@3x.png"); }
      .optionMenu .optionMenu__content .optionMenu__section .optionMenu__item.optionMenu__item--sanction::before {
        background-image: url("https://static.popdaily.com.tw/img/globalicon/share-sanction@3x.png"); }
  .optionMenu .optionMenu__content .optionMenu__section:not(:last-child) {
    border-bottom: solid 1px #e1e1e1; }
  .optionMenu .optionMenu__btn {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-bottom: calc(20px + constant(safe-area-inset-bottom));
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    border-top: 1px solid #e3e3e3;
    background-color: #fff;
    cursor: pointer;
    text-align: center; }
`